module.exports = "/_next/static/images/20-1-3cbc1b80b9e978793e38441404a40e5e.svg";